import React from 'react';

function App() {
  return (

      <h1>Este es un texto de prueba en una página básica.</h1>
   
  );
}

export default App;
